import styled from 'styled-components';

export const ContainerOuter = styled.div`
    min-height: 100vh;
    background-size: 100%;
    background-position: center;
    background-image: url('/Assets/background_2.jpg');
    @media (min-width: 1000px) {
        background-size: contain;
    }
`;

export const ResponseContainer = styled.div`
    min-height: 90vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ResponseMessage = styled.h4`
    font-size: 18px;
    color: #121180;
    font-weight: 600;
    margin-top: 10px;
    text-align: center;
`;